import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { UserContext } from '../common/UserContext';
import config from "../../envconfig";

const ShipmentDetail = () => {
  const [shipmentDetails, setShipmentDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const { shipmentCode } = useParams();
  // const { UM_CompanyID, UM_GroupId, UM_CompanyGrpID, UM_UserId, UM_UserCode, selectedScpId } = useParams();
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  const cameFromSCT = sessionStorage.getItem("fromSCT") === "yes";
  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);

    sessionStorage.setItem('selectedScpId', selectedScpId);

  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

  const [selectedenumStatus, setSelectedenumStatus] = useState('');

  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Shipment Outward Creation:", action, userCode: UM_UserCode, isError }),
      });
      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  useEffect(() => {
    const fetchShipment = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${config.API_URL}/api/shipment/full/${shipmentCode}`);
        const data = await res.json();

        setShipmentDetails(data);
        setSelectedenumStatus(data.shipmentDetails.SHPH_Status);
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };

    fetchShipment();
  }, [shipmentCode]);

  if (loading) {
    logAction("Loading: Shipment details are being fetched");
    return <div
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        zIndex: 1000,
      }}
    />;
  }

  if (!shipmentDetails) {
    logAction("Failed: Shipment details could not be loaded");
    return <div>Failed to load shipment details.</div>;
  }

  return (
    <>
      <div className='main_container'>
        <div className="row">
          <div className="col-md-12">
            <h2 className="formHeading">Shipment Master</h2>
            <form>
              <div className="row mb-2">
                <div className="col sm-6">
                  <label className="form-label">Shipment Type</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.SHPH_ShipmentType || ''}
                    disabled
                  />
                </div>
                <div className="col sm-6">
                  <label className="form-label">Shipment Date</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.SHPH_ShipmentDate || ''}
                    disabled
                  />
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-sm-6">
                  <label className="form-label">Logistic Party Name</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.LGCM_Name || ''}
                    disabled
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label">Vehicle Number</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.LGCVM_VehicleNumber || ''}
                    disabled
                  />
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-sm-6">
                  <label className="form-label">Driver Name</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.SHPH_DriverName || ''}
                    disabled
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label">Driver Phone Number</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.SHPH_DriverContactNo || ''}
                    disabled
                  />
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-sm-6">
                  <label className="form-label">Scanning Mode</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.SHPH_ByProductVendorScanMode === 1 ? 'Vendor' : 'Product'}
                    disabled
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label">Shipment Status</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.StatusDescription || ''}
                    disabled // Make the input read-only to display the status
                  />
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-sm-6">
                  <label className="form-label">Route for Shipment Location</label>
                  <input
                    type="text"
                    className="form-input"
                    value={shipmentDetails.shipmentDetails.RUTL_Name || ''}
                    disabled
                  />
                </div>

              </div>

            </form>
            <div className="table-responsive mt-3">
              <table className="tableClass">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>SCP Name</th>
                    <th>Order Number</th>
                    <th>Product Name</th>
                    <th>Product Code</th>
                    <th>Ordered Quantity</th>
                    <th>Ship Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(shipmentDetails.tableData) && shipmentDetails.tableData.length > 0 ? (
                    shipmentDetails.tableData.map((row, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{row.SCPM_Name}</td>
                        <td>{row.ORDM_OrderNumber}</td>
                        <td>{row.SHPD_ProductName}</td>
                        <td>{row.SHPD_ProductCode}</td>
                        <td>{row.orderedQty}</td>
                        <td>{row.shipQty}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7">No data available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {cameFromSCT ? (
        <Link to={`/dashboard/SupplyChainTransaction`} className="back_btn">
          BACK
        </Link>
      ) : (
        <Link to={`/shipmentlist`} className="back_btn">
          BACK
        </Link>
      )}
    </>
  );
};

export default ShipmentDetail;

